import { type PlanTier, getPlanDisplayName } from "@reactive-resume/utils";
import { create } from "zustand";

export type { PlanTier };
export { getPlanDisplayName };

interface BillingState {
  paywallOpen: boolean;
  paywallFeature: string | null;
  paywallMessage: string | null;
}

interface BillingActions {
  openPaywall: (feature?: string, message?: string) => void;
  closePaywall: () => void;
}

export const useBillingStore = create<BillingState & BillingActions>()((set) => ({
  paywallOpen: false,
  paywallFeature: null,
  paywallMessage: null,
  openPaywall: (feature, message) =>
    set({ paywallOpen: true, paywallFeature: feature ?? null, paywallMessage: message ?? null }),
  closePaywall: () => set({ paywallOpen: false, paywallFeature: null, paywallMessage: null }),
}));
